import { IFrameData } from '@leafer-ui/interface'

import { BoxData } from './BoxData'


export class FrameData extends BoxData implements IFrameData {

}
